/* IDGAF smooth scroll — JS-only, no CSS scroll-behavior conflict */
(function(){
  var DURATION = 380;
  var HEADER_OFFSET = 80;

  function ease(t){ return t<.5 ? 2*t*t : -1+(4-2*t)*t; }

  function smoothScrollTo(target){
    /* Kill any native smooth scroll mid-flight */
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.style.scrollBehavior = 'auto';

    var start = window.pageYOffset;
    var targetY = target.getBoundingClientRect().top + start - HEADER_OFFSET;
    var distance = targetY - start;
    var startTime = null;

    function step(ts){
      if(!startTime) startTime = ts;
      var elapsed = ts - startTime;
      var p = Math.min(elapsed / DURATION, 1);
      /* behavior:'instant' prevents browser from re-applying smooth scroll on top */
      window.scrollTo({ top: start + distance * ease(p), behavior: 'instant' });
      if(p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  document.addEventListener('click', function(e){
    var link = e.target.closest('a[href^="#"]');
    if(!link) return;
    var hash = link.getAttribute('href');
    if(!hash || hash === '#') return;
    var target = document.querySelector(hash);
    if(!target) return;
    e.preventDefault();
    smoothScrollTo(target);
    history.pushState(null, null, hash);
  }, { passive: false });
})();
